var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoneDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 106,
    viewBox: "0 0 154 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 143.444,
    height: 66.2507,
    transform: "matrix(1 -6.84593e-08 -1.11601e-07 -1 4.51282 94.958)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 130.404,
    height: 11.0418,
    transform: "matrix(1 -9.08709e-08 -8.411e-08 -1 12.5376 101.985)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.83232,
    height: 10.9799,
    transform: "matrix(1 -6.76116e-08 -1.12998e-07 -1 11.287 100.561)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.83232,
    height: 10.9799,
    transform: "matrix(1 -6.76116e-08 -1.12998e-07 -1 9.04102 97.144)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.83232,
    height: 14.1943,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 7.0708 41.1655)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.83232,
    height: 18.8728,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 33.3138 24.0776)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.83232,
    height: 18.8728,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 38.5636 28.4155)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.83232,
    height: 18.8728,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 43.0951 36.4077)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.01552,
    height: 11.0418,
    transform: "matrix(1 -9.72374e-08 -7.86104e-08 -1 140.935 96.9658)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 5.01552,
    height: 14.0532,
    transform: "matrix(1 -1.25722e-07 -6.08222e-08 -1 139.932 37.7417)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 131.407,
    height: 14.0532,
    transform: "matrix(1 -1.21468e-07 -6.29491e-08 -1 10.5315 35.7339)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6781 21.7661L31.3436 21.7661L31.3436 4.33748L35.6781 4.33748L35.6781 21.7661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0125 4.3374L35.6781 4.3374L35.6781 -4.1008e-05L40.0125 -4.13869e-05L40.0125 4.3374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4258 8.75342L40.0913 8.75342L40.0913 4.41597L44.4257 4.41597L44.4258 8.75342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7602 13.0913L44.4258 13.0913L44.4258 8.75387L48.7602 8.75386L48.7602 13.0913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0947 17.4287L48.7603 17.4287L48.7603 13.0913L53.0947 13.0913L53.0947 17.4287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5079 21.7661L53.1735 21.7661L53.1735 17.4287L57.5079 17.4287L57.5079 21.7661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.932 21.6811L47.6462 21.6812L47.6462 17.666L139.932 17.666L139.932 21.6811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6781 21.7661L15.8185 21.7661L15.8185 17.4287L35.6781 17.4287L35.6781 21.7661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.932 104.996L14.5438 104.996L14.5438 99.9771L139.932 99.9771L139.932 104.996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.372 91.7192L149.038 91.7192L149.038 30.3553L153.372 30.3553L153.372 91.7192Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.624 100.278L140.29 100.278L140.29 95.9409L144.624 95.9409L144.624 100.278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.959 95.8613L144.624 95.8613L144.624 91.5239L148.959 91.5239L148.959 95.8613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.625 26.0186L140.29 26.0186L140.29 21.6811L144.625 21.6811L144.625 26.0186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.959 30.356L144.625 30.356L144.625 26.0185L148.959 26.0185L148.959 30.356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07077 91.8838L2.73633 91.8838L2.73632 30.5199L7.07076 30.5199L7.07077 91.8838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8185 100.442L11.484 100.442L11.484 96.1049L15.8185 96.1049L15.8185 100.442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4052 96.0259L7.0708 96.0259L7.0708 91.6884L11.4052 91.6884L11.4052 96.0259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8185 26.1821L11.484 26.1821L11.484 21.8447L15.8185 21.8447L15.8185 26.1821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4052 30.52L7.0708 30.52L7.0708 26.1826L11.4052 26.1826L11.4052 30.52Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3138 22.5547L28.9794 22.5547L28.9794 5.12606L33.3138 5.12606L33.3138 22.5547Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6483 5.12598L33.3138 5.12598L33.3138 0.788533L37.6483 0.788533L37.6483 5.12598Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0616 9.54248L37.7272 9.54248L37.7272 5.20504L42.0616 5.20504L42.0616 9.54248Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.396 13.8799L42.0615 13.8799L42.0615 9.54244L46.396 9.54244L46.396 13.8799Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7304 18.2178L46.396 18.2178L46.396 13.8803L50.7304 13.8803L50.7304 18.2178Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1436 22.5547L50.8092 22.5547L50.8092 18.2172L55.1436 18.2172L55.1436 22.5547Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 22.6846L46.6432 22.6846L46.6432 18.6694L137.926 18.6694L137.926 22.6846Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3138 22.5547L13.4542 22.5547L13.4542 18.2172L33.3138 18.2172L33.3138 22.5547Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.926 106L13.5408 106L13.5408 100.981L137.926 100.981L137.926 106Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.008 92.313L146.673 92.313L146.673 30.9491L151.008 30.9491L151.008 92.313Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.26 101.067L137.926 101.067L137.926 96.7295L142.26 96.7295L142.26 101.067Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.595 96.6504L142.26 96.6504L142.26 92.3129L146.595 92.3129L146.595 96.6504Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.26 26.8071L137.926 26.8071L137.926 22.4697L142.26 22.4697L142.26 26.8071Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.595 31.1445L142.26 31.1445L142.26 26.8071L146.595 26.8071L146.595 31.1445Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70651 92.4771L0.37207 92.4771L0.372063 31.1132L4.7065 31.1132L4.70651 92.4771Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4542 101.231L9.11975 101.231L9.11975 96.8935L13.4542 96.8935L13.4542 101.231Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04098 96.8145L4.70654 96.8145L4.70654 92.477L9.04098 92.477L9.04098 96.8145Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4542 26.9712L9.11975 26.9712L9.11975 22.6337L13.4542 22.6337L13.4542 26.9712Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04098 31.3086L4.70654 31.3086L4.70654 26.9712L9.04098 26.9712L9.04098 31.3086Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7126 54.4136V38.858H24.1571V43.3025H26.3793V41.0802H28.6015V38.858H33.046V41.0802H30.8238V43.3025H28.6015V45.5247H26.3793V47.7469H28.6015V49.9691H30.8238V52.1914H33.046V54.4136H28.6015V52.1914H26.3793V49.9691H24.1571V54.4136H19.7126ZM39.704 52.1914H44.1484V45.5247H39.704V52.1914ZM37.4817 52.1914H35.2595V45.5247H37.4817V43.3025H48.5929V54.4136H37.4817V52.1914ZM59.6953 52.1914H57.4731V47.7469H59.6953V52.1914ZM61.9175 45.5247V43.3025H66.362V54.4136H61.9175V47.7469H59.6953V45.5247H61.9175ZM55.2508 47.7469V54.4136H50.8064V43.3025H55.2508V45.5247H57.4731V47.7469H55.2508ZM79.6909 43.3025V45.5247H81.9132V49.9691H73.0243V52.1914H81.9132V54.4136H70.8021V52.1914H68.5798V45.5247H70.8021V43.3025H79.6909ZM77.4687 45.5247H73.0243V47.7469H77.4687V45.5247ZM93.0156 54.4136V49.9691H88.5712V54.4136H84.1267V43.3025H88.5712V47.7469H93.0156V43.3025H97.46V54.4136H93.0156ZM110.785 49.9691H113.007V52.1914H110.785V54.4136H99.6736V43.3025H104.118V47.7469H110.785V49.9691ZM108.562 52.1914V49.9691H104.118V52.1914H108.562Z",
    fill: "#444042"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6163 77.4314V80.5425H20.0608V72.7647H21.6163V75.8758H26.283V72.7647H27.8386V80.5425H26.283V77.4314H21.6163ZM30.9542 78.9869H29.3987V74.3203H30.9542V78.9869ZM35.6209 75.8758H34.0653V74.3203H35.6209V72.7647H37.1765V80.5425H35.6209V78.9869H34.0653V77.4314H35.6209V75.8758ZM34.0653 80.5425H30.9542V78.9869H34.0653V80.5425ZM34.0653 74.3203H30.9542V72.7647H34.0653V74.3203ZM40.2921 80.5425V82.098H38.7366V78.9869H40.2921V74.3203H41.8477V78.9869H44.9588V74.3203H46.5143V78.9869H48.0699V82.098H46.5143V80.5425H40.2921ZM44.9588 74.3203H41.8477V72.7647H44.9588V74.3203ZM55.8416 74.3203H51.1749V72.7647H55.8416V74.3203ZM51.1749 77.4314V78.9869H49.6194V74.3203H51.1749V75.8758H55.8416V74.3203H57.3972V77.4314H51.1749ZM57.3972 80.5425H51.1749V78.9869H57.3972V80.5425ZM63.6239 75.8758H65.1795V77.4314H63.6239V80.5425H62.0684V77.4314H60.5128V75.8758H62.0684V72.7647H63.6239V75.8758ZM66.7351 80.5425H65.1795V77.4314H66.7351V80.5425ZM66.7351 75.8758H65.1795V72.7647H66.7351V75.8758ZM60.5128 80.5425H58.9573V77.4314H60.5128V80.5425ZM60.5128 75.8758H58.9573V72.7647H60.5128V75.8758ZM69.8507 77.4314V80.5425H68.2952V72.7647H69.8507V75.8758H74.5174V72.7647H76.0729V80.5425H74.5174V77.4314H69.8507ZM79.1886 78.9869H77.6331V74.3203H79.1886V78.9869ZM83.8553 74.3203H79.1886V72.7647H83.8553V74.3203ZM85.4108 78.9869H83.8553V74.3203H85.4108V78.9869ZM83.8553 80.5425H79.1886V78.9869H83.8553V80.5425ZM88.5265 78.9869H86.9709V74.3203H88.5265V78.9869ZM94.7487 74.3203H88.5265V72.7647H94.7487V74.3203ZM94.7487 80.5425H88.5265V78.9869H94.7487V80.5425ZM100.976 74.3203V80.5425H99.4199V74.3203H96.3088V72.7647H104.087V74.3203H100.976ZM113.425 78.9869H111.869V77.4314H113.425V78.9869ZM107.202 75.8758H111.869V77.4314H107.202V78.9869H111.869V80.5425H105.647V72.7647H107.202V75.8758Z",
    fill: "#1B1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneDesc);
export default __webpack_public_path__ + "static/media/stoneDesc.c9bc1287d8a4406eda84ac4ff5a18222.svg";
export { ForwardRef as ReactComponent };